<template>
  <div class="verify">
    <div v-if="order">
      <div v-if="!order.verify">
        <h1 class="text-center my-5">متاسفانه پرداخت شما با شکست مواجه شد</h1>
        <v-alert
          border="left"
          text
          type="error"
          icon="mdi-alert-circle"
          transition="scale-transition"
        >
          <h4 class="grow">
            {{ this.$route.query.error }}
          </h4>
        </v-alert>
      </div>
      <div v-else>
        <v-alert dense type="success" class="text-center my-5">
          پرداخت شما با موفقیت انجام شد
        </v-alert>
        <div v-if="order.type == 'کد تخفیف'">
          <v-row class="mb-2">
            <v-col cols="12">
              <h3 class="text-center pt-3">
                فاکتور خرید کتاب های بسته توسعه سواد خواندن
              </h3>
            </v-col>
            <v-col cols="12" md="6">
              فروشنده: موسسه مدارس یادگیرنده مرآت
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-left">
                خریدار: {{ order.user.firstname + " " + order.user.lastname }}
              </div>
            </v-col>
          </v-row>
          <v-simple-table class="text-center mb-8">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="font-weight-bold">نام سری کد تخفیف</td>
                  <td>
                    <strong>{{ order.discountCodeTitle }}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">تعداد درخواستی</td>
                  <td>
                    <strong>{{ order.discountCodeCount }} </strong>
                    <small>عدد</small>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">تخفیف اعمال شده</td>
                  <td><strong>30</strong> <small>%</small></td>
                </tr>
                <tr>
                  <td class="font-weight-bold">جمع فاکتور</td>
                  <td>
                    <strong>{{ order.totalAmount }}</strong> <small>ریال</small>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">تاریخ خرید</td>
                  <td>
                    <strong>
                      <persian-date
                        :date="
                          order.verifyDateTime
                            ? order.verifyDateTime
                            : order.createDateTime
                        "
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">کد ارجاع</td>
                  <td>
                    <strong>{{ order.saleReferenceId }}</strong>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-btn
            block
            depressed
            color="primary"
            router
            :to="{ name: 'SchoolOrders' }"
            >مشاهده کد های تخفیف</v-btn
          >
        </div>
        <div v-else>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <v-img
                contain
                class="re-rounded re-shadow mx-auto"
                elevation="10"
                width="250"
                :src="
                  'https://dl.pirls.ir/app/bookcovers/' +
                  order.book._id +
                  '.jpg'
                "
              />
            </v-col>
            <v-col cols="12" md="9" sm="8">
              <v-simple-table class="text-center mb-8">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold">نام کتاب</td>
                      <td>
                        <strong>{{ order.book.title }} </strong>
                        <small>( {{ order.book.moralvalue }} )</small>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">پایه</td>
                      <td>
                        <strong>{{ order.book.grade }} </strong>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">مبلغ پرداختی</td>
                      <td>
                        <strong>{{ order.totalAmount }} </strong>
                        <small>ریال</small>
                      </td>
                    </tr>
                    <tr v-if="order.discountCode">
                      <td class="font-weight-bold">کد تخفیف استفاده شده</td>
                      <td>
                        <strong>{{ order.discountCode.code }}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">تاریخ خرید</td>
                      <td>
                        <strong>
                          <persian-date
                            :date="
                              order.verifyDateTime
                                ? order.verifyDateTime
                                : order.createDateTime
                            "
                          />
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">کد ارجاع</td>
                      <td>
                        <strong>{{ order.saleReferenceId }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn
                block
                depressed
                color="primary"
                router
                :to="{ name: 'Book', params: { id: order.book._id } }"
                >مطالعه کتاب</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "verify-component",
  data() {
    return {
      order: null
    };
  },
  created() {
    this.handleGetOrderData();
  },
  methods: {
    handleGetOrderData() {
      this.$api.get("/order/" + this.$route.params.id).then((res) => {
        this.order = res.data.order;
      });
    }
  }
};
</script>
